import { DataState, IDataAction } from "../actions/types/dataTypes";

const initialState: DataState = {
  user: null,
  search: undefined,
  config: undefined,
  loading: false,
  loaded: false,
  findCompanion: null,
  isLoadingUserData: false,
};

export const dataReducer = (
  state: DataState = initialState,
  action: IDataAction<any>
): DataState => {
  switch (action.type) {
    case "SAVE_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SAVE_AUTHORIZATION":
      return {
        ...state,
        user: { ...state.user, authorizations: action.payload },
      };
    case "DATA_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "DATA_LOADED":
      return {
        ...state,
        loaded: action.payload,
      };
    case "DATA_SEARCH":
      return {
        ...state,
        search: action.payload,
      };
    case "DATA_CONFIG":
      return {
        ...state,
        config: action.payload,
      };
    case "DATA_SET_FIND_COMPANION": {
      return {
        ...state,
        findCompanion: action.payload,
      };
    }
    case "RESET":
      return initialState;
    default:
      return state;
  case "IS_LOADING_USER_DATA":
    return {
      ...state,
      isLoadingUserData: action.payload,
    };
}};
